import { Injectable } from '@angular/core';

import { TrackChangesVisibilityState } from '../model';
import {
  createDefaultTrackChangesVisibilityState,
  getTrackChangesVisibilityClassMap,
} from '../utils/track-changes-visibility.util';

/**
 * Owns Track Changes visibility state and behavior shared by the CKEditor edit
 * view and the read-only preview viewer. Must be provided per-component so
 * each rendering context keeps independent session-level visibility state.
 */
@Injectable()
export class TrackChangesVisibilityService {
  public showPanel = false;

  public state: TrackChangesVisibilityState =
    createDefaultTrackChangesVisibilityState();

  public get classMap(): Record<string, boolean> {
    return getTrackChangesVisibilityClassMap(this.state);
  }

  public togglePanel(): void {
    this.showPanel = !this.showPanel;
  }

  public setMasterVisibility(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.state = {
      ...this.state,
      masterVisible: target.checked,
    };
  }

  public setInsertionsVisibility(event: Event): void {
    if (!this.state.masterVisible) {
      return;
    }
    const target = event.target as HTMLInputElement;
    this.state = {
      ...this.state,
      insertionsVisible: target.checked,
    };
  }

  public setDeletionsVisibility(event: Event): void {
    if (!this.state.masterVisible) {
      return;
    }
    const target = event.target as HTMLInputElement;
    this.state = {
      ...this.state,
      deletionsVisible: target.checked,
    };
  }

  public setFormattingVisibility(event: Event): void {
    if (!this.state.masterVisible) {
      return;
    }
    const target = event.target as HTMLInputElement;
    this.state = {
      ...this.state,
      formattingVisible: target.checked,
    };
  }

  public handleOutsideClick(
    control: HTMLElement | null,
    target: EventTarget | null
  ): void {
    if (this.showPanel && control && !control.contains(target as Node)) {
      this.showPanel = false;
    }
  }
}
